export class Document {
  type: string;
  value: string;
}
